module.exports = __webpack_public_path__ + "img/fluentbit.11f295b7.png";